// extracted by mini-css-extract-plugin
export default {"addProductSection":"style_addProductSection__BpzI2","actionsSection":"style_actionsSection__fDTbi","formSection":"style_formSection__-mKiE"};